<template>
  <div class="content">
    <p>
      <em class="bule"
        >医用分子筛制氧系统已经在一些医疗机构普遍使用，推行富氧空气（93%氧）的使用势在必行。</em
      >
    </p>
    <p>
      人体的新陈代谢离不开氧气，人体呼吸及生理对医用氧的含量≥90%（mL·mL¯¹）就可以满足用于缺氧的预防和治疗的要求。由于制备方法不同，国家食品药品监督管理局对医用氧和富养空气（93%）制定了不同的质量标准，既要满足对有效成分含氧量的规定，也要严格控制备过程中产生杂质和对人体有害的成分，这样规定是科学而合理的。
    </p>
    <p>
      <em class="red"
        >法规明确规定医用分子筛变压吸附制备的氧气，其浓度范围在90%~96%（mL ·
        mL-1）之间，可以作为医疗机构供氧系统集中供氧的氧源设备，是医用气体管道系统用氧气浓缩器供气系统的主要组成部分。</em
      ><em class="bule"
        >医用分子筛制氧系统为患者提供安全、有效的临床用氧，提高人民群众的健康水平。</em
      >
    </p>
    <p><em class="bule">人体呼吸生理对氧含量的要求</em></p>
    <p>
      是不是医用氧气的氧含量一定要不低于99%才能满足医疗和保健要求呢？从人体呼吸生理来看，人体进行新陈代谢离不开氧气，缺氧对人体有害，严重缺氧时会有生命危险。但正常人若较长时间吸入纯氧时，不但对人体无益反而有可能引发氧中毒症。因为长时间吸入纯氧时，肺泡的CO2分压很低，流经肺部动脉血液中的CO2分压急剧下降，缺乏生理的“CO2对呼吸的刺激”，导致呼吸暂停。另一方面，当大量吸入“纯氧”时，肺泡被氧分子占领，动脉血流经肺部时，血液中的CO2得不到应有的扩散排除，致使血液中的CO2分压增高。如果血液中的CO2分压超过71mmHg(>10kPa),在这样高的浓度下，CO2对呼吸中枢具有麻醉的作用，致使呼吸停止或下降。因此，Schmidt教授等提出：“为了排除氧中毒，在长时间持续等压氧疗时，对成年人要应用氧浓度低于60%和氧分压低于450mmHg(60kPa)的混合气体，治疗新生儿或乳儿时所用的混合气体，其氧气浓度不应超过60%，其氧分压不应超过300mmHg(≤40kPa)”。
    </p>
    <p>
      <em class="red"
        >可见，从人体呼吸生理角度考虑，并不需要吸入氧含量为100%的纯氧。</em
      >
    </p>
    <p>
      <em class="bule"
        >为防止在抢救和治疗过程中，因吸入“纯氧”而引发氧中毒症，所有的呼吸机和麻醉机的氧含量调整范围均定在21%～90%。</em
      ><em class="red"
        >这一规定表明，只要医用氧气的氧含量≥
        90%，就可以满足呼吸机和麻醉机对病人进行抢救和治疗的需要。</em
      >
    </p>
    <p><em class="bule">不同制氧原理对氧气浓度的要求</em></p>
    <p>
      深冷法的特点是无论是在空气液化还是蒸馏，都是在120K以下的温度条件下进行的；液氧经过长期的弱放电，变成液态臭氧；由于烃（即碳氢化合物）能溶于液氧，此法不能完全析出空气中的烃等。此法制得的氧气，其成分除了氧气以外，还有水分、二氧化碳、一氧化碳、气态酸和碱、臭氧及烃等对人体有害的成分。如果对氧含量的规定低于99.5%，则这些对人体有害的成分就会相应增加，超过«医用氧气»国家标准和«中国药典»规定的含量，从而对人体造成危害。此即医用氧气氧含量必须不低于99.5%的由来。
    </p>
    <p>
      这种方法采用纯物理吸附，产生的氧气浓度为90%-96%，低于«医用氧气»国家标准对医用氧含量要求不低于99.5%的要求，但有害成分（如烃和固体物质等）的含量低于国家标准中对其的限制（如表1所示）
    </p>
    <div>
      <table>
        <thead>
          <tr>
            <th colspan="4" class="table-title">
              表1深冷法和分子筛制氧法含量要求比较
            </th>
          </tr>
          <tr>
            <th colspan="2" class="column-header">项目</th>
            <th class="column-header">«医用氧气»国家标准对医用氧含量要求</th>
            <th class="column-header">
              «医用分子筛制氧设备通用技术规范»对氧含量要求（分子筛）
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="2" class="row-header">氧含量（体积分数）（V/V）</td>
            <td class="center-text">≥99.5%</td>
            <td class="center-text">≥90%</td>
          </tr>
          <tr>
            <td colspan="2" class="row-header">水分含量</td>
            <td class="center-text">露点-43摄氏度</td>
            <td class="center-text">≤0.07g/lm³</td>
          </tr>
          <tr>
            <td colspan="2" class="row-header">二氧化碳含量（V/V）</td>
            <td class="center-text">≤0.01%</td>
            <td class="center-text">≤0.01%</td>
          </tr>
          <tr>
            <td colspan="2" class="row-header">一氧化碳含量（V/V）</td>
            <td class="center-text">≤5x10⁻⁶</td>
            <td class="center-text">应符合GB8986-88中的第5章规定</td>
          </tr>
          <tr>
            <td colspan="2" class="row-header">气态酸性物质和碱性物质含量</td>
            <td class="center-text">按5.4检验合格</td>
            <td class="center-text">应符合GB8986-88中的第6章规</td>
          </tr>
          <tr>
            <td colspan="2" class="row-header">臭氧及其他其他氧化物</td>
            <td class="center-text">按5.5检验合格</td>
            <td class="center-text">应符合GB8986-88中的第7章规</td>
          </tr>
          <tr>
            <td colspan="2" class="row-header">气味</td>
            <td class="center-text">无异味</td>
            <td class="center-text">无异味</td>
          </tr>
          <tr>
            <td colspan="2" class="row-header">总烃含量（体积分数）（V/V）</td>
            <td class="center-text">≤60x10⁻⁶</td>
            <td class="center-text">________</td>
          </tr>
          <tr>
            <td rowspan="2" class="row-header">固体物质</td>
            <td class="row-header">粒度/um</td>
            <td class="center-text">≤100</td>
            <td class="center-text">≤10</td>
          </tr>
          <tr>
            <td class="row-header">含量/mg/m³</td>
            <td class="center-text">≤1</td>
            <td class="center-text">≤0.5</td>
          </tr>
          <tr>
            <td colspan="2" class="row-header">备注</td>
            <td class="center-text">液态医用氧对气味、水分含量不作规定</td>
            <td class="center-text">—————</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      <em class="bule"
        >为什么钢瓶氧、液氧的氧气浓度要求是不低于99.5%，分子筛制氧的氧气浓度≧90%即可？</em
      ><em class="red"
        >因制氧原理的要求不同，残留对人体有害的成分含量不同，所以对氧气浓度的要求也不同。</em
      >
    </p>
    <p>
      综上所述，可以归结为二点：一是«医用氧气»国家标准和«中国药典»所规定的医用氧气氧含量不能低于99%，并不意味着医院不能把氧含量低于99%的氧气用于缺氧的预防好热治疗；二是医院用于缺氧的预防和治疗的氧气，其氧含量只要≥90%即可满足使用要求。但是都要有前提条件，这前提条件就是氧气里对人体有害成分的含量不能超过«医用氧气»国家标准的规定值。
    </p>
  </div>
</template>

<script>
export default {
  name: 'TabOxygenConcentrationFAQ'
}
</script>

<style lang="scss" scoped>
.content {
  font-size: 18px;
  color: #6a6a6a;
  p {
    line-height: 36px;
    text-indent: 40px;
  }
  .bule {
    color: #008ded;
  }
  .red {
    color: red;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
  }

  th,
  td {
    border: 1px solid #000;
    padding: 8px;
    text-align: center;
  }

  .table-title {
    text-align: center;
  }

  .column-header {
    text-align: center;
    font-size: 18px;
    line-height: 25px;
  }

  .row-header {
    width: 130px;
    text-align: center;
  }

  .center-text {
    text-align: center;
  }
}
</style>
